import { render, staticRenderFns } from "./xjxx.vue?vue&type=template&id=0ef5644a&scoped=true"
import script from "./xjxx.vue?vue&type=script&lang=js"
export * from "./xjxx.vue?vue&type=script&lang=js"
import style0 from "./xjxx.vue?vue&type=style&index=0&id=0ef5644a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5644a",
  null
  
)

export default component.exports